import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import * as Icons from '../../Utils/Icons'
import Downshift from 'downshift'
import { Link } from 'react-router-dom'

// THIS COMPONENT IS DEPRECATED
// If you want to create a Dropdown menu, please use a combination of
// PopoverOnClick + Menu instead (example in NoteRow)

class Dropdown extends Component {
  static propTypes = {
    preventCloseOnSelect: PropTypes.bool,
    defaultIsOpen: PropTypes.bool,
  }

  static defaultProps = {
    preventCloseOnSelect: false,
    defaultIsOpen: false,
  }

  constructor(props) {
    super(props)
    const { preventCloseOnSelect } = props

    this.state = preventCloseOnSelect ? { isOpen: false } : { isOpen: null }
  }

  componentDidMount() {
    const { preventCloseOnSelect } = this.props
    if (!preventCloseOnSelect) {
      return false
    }
    this._isMounted = true
    const onMouseDown = () => {
      this.isMouseDown = true
    }
    const onMouseUp = event => {
      this.isMouseDown = false
      if (
        (event.target === this.downshift._rootNode ||
          !this.downshift._rootNode.contains(event.target)) &&
        this.state.isOpen
      ) {
        this.setState({ isOpen: false })
      }
    }
    window.addEventListener('mousedown', onMouseDown)
    window.addEventListener('mouseup', onMouseUp)

    this.cleanup = () => {
      this._isMounted = false
      window.removeEventListener('mousedown', onMouseDown)
      window.removeEventListener('mouseup', onMouseUp)
    }
  }

  componentWillUnmount() {
    this.cleanup && this.cleanup()
  }

  render() {
    const {
      children,
      onSelect,
      preventCloseOnSelect,
      defaultIsOpen,
      ...restProps
    } = this.props

    const { isOpen } = this.state

    const controlledProps = preventCloseOnSelect ? { isOpen } : {}

    return (
      <Downshift
        defaultIsOpen={defaultIsOpen}
        ref={downshift => {
          this.downshift = downshift
        }}
        onChange={(item, props) => {
          if (item) {
            onSelect(item)
          }
          props.toggleMenu()
          props.clearSelection()
        }}
        {...controlledProps}
        {...restProps}
      >
        {({ getButtonProps, ...restProps }) =>
          children({
            closePopover: () => this.setState({ isOpen: false }),
            getButtonProps: args => ({
              ...getButtonProps(args),
              onClick: event => {
                preventCloseOnSelect
                  ? this.setState({ isOpen: !this.state.isOpen })
                  : this.downshift.toggleMenu()
              },
            }),
            ...restProps,
          })
        }
      </Downshift>
    )
  }
}

const Wrapper = ({ children, innerRef, className, ...restProps }) => (
  <div
    ref={innerRef}
    className={classNames('position-relative inline-block', className)}
    {...restProps}
  >
    {children}
  </div>
)

const Body = ({
  children,
  innerRef,
  style = {},
  placement,
  placementCustomStyle = {},
  className,
  ...restProps
}) => {
  let placementStyle = {}
  if (placement) {
    placementStyle = { position: 'absolute' }
    switch (placement) {
      case 'left':
        placementStyle = {
          ...placementStyle,
          top: 0,
          right: '100%',
          left: 'auto',
          bottom: 'auto',
        }
        break
      case 'right':
        placementStyle = {
          ...placementStyle,
          top: 0,
          left: '100%',
          right: 'auto',
          bottom: 'auto',
        }
        break
      case 'top':
        placementStyle = {
          ...placementStyle,
          top: 'auto',
          left: '0',
          right: '100%',
          bottom: 'auto',
        }
        break
      case 'bottom':
        placementStyle = {
          ...placementStyle,
          top: '100%',
          left: '0',
          right: 'auto',
          bottom: 'auto',
        }
        break
      case 'bottom-left':
        placementStyle = {
          ...placementStyle,
          top: '100%',
          left: 'auto',
          right: '0',
          bottom: 'auto',
        }
        break
      case 'custom':
        placementStyle = {
          ...placementStyle,
          ...placementCustomStyle,
        }
        break
      default:
        break
    }
  }
  return (
    <div
      ref={innerRef}
      className={classNames(
        'dropdown-body color-mode-elevated shadow-hovering radius-large overflow-hidden zindex-medium text-align-left background-shade-100',
        className
      )}
      style={{
        width: 320,
        ...placementStyle,
        ...style,
      }}
      {...restProps}
    >
      {children}
    </div>
  )
}

const Menu = ({ scrolling = false, maxHeight = 260, className, children }) => {
  return (
    <div
      className={classNames(
        {
          'scroll-y': scrolling,
        },
        className
      )}
      style={{
        maxHeight: scrolling ? maxHeight : null,
      }}
    >
      {children}
    </div>
  )
}

const Title = ({ children, className }) => {
  return (
    <div
      className={classNames(
        'background-shade-100 padding-vertical-normal padding-horizontal-medium bold border-bottom-medium border-shade-50',
        className
      )}
    >
      {children}
    </div>
  )
}

const Header = ({ children, className }) => {
  return (
    <div
      className={classNames('background-shade-100 padding-medium', className)}
    >
      {children}
    </div>
  )
}

const Divider = ({ children }) =>
  children ? (
    <div
      className="background-shade-50 full-width padding-horizontal-large padding-vertical-small font-size-smaller uppercase shade-30 bold"
      style={{ letterSpacing: '1px' }}
    >
      {children}
    </div>
  ) : (
    <div className="background-shade-50 full-width" style={{ height: 2 }} />
  )

const Item = React.forwardRef(
  (
    {
      icon,
      children,
      divider = false,
      subtitle,
      selected,
      style,
      className,
      disabled,
      ...restProps
    },
    ref
  ) => (
    <div
      className={classNames(
        'transition',
        'padding-vertical-normal padding-horizontal-medium pointer',
        'background-shade-50-on-active',
        'font-weight-medium shade-05',
        {
          'border-bottom-medium border-shade-50': divider,
          'background-shade-50': selected,
          'background-shade-100': !selected,
          'background-shade-100 cursor-forbidden': disabled,
          'background-shade-50-on-hover background-shade-50-on-focus': !disabled,
        },
        className
      )}
      ref={ref}
      style={style}
      {...restProps}
    >
      <div className="flexbox flexbox-align-center">
        {icon && (
          <div className="flexbox-no-grow padding-right-normal shade-30">
            {icon}
          </div>
        )}
        <div className="flexbox-grow">
          {subtitle ? (
            <div style={{ lineHeight: '14px' }}>
              <div className="font-weight-medium">{children}</div>
              <div className="font-weight-regular font-size-smaller">
                {subtitle}
              </div>
            </div>
          ) : (
            <div>{children}</div>
          )}
        </div>
      </div>
    </div>
  )
)

const Button = ({ children, selected, to, ...restProps }) =>
  React.createElement(
    to ? Link : 'div',
    {
      className: classNames(
        'padding-medium pointer',
        'background-shade-100 background-shade-50-on-hover background-shade-50-on-focus',
        'font-weight-medium shade-05 center-text',
        {
          'background-shade-50 shade-05': selected,
        }
      ),
      to,
      style: { display: 'block' },
      ...restProps,
    },
    children
  )

const SearchInput = ({ value, ...restProps }) => (
  <div className="background-shade-100 padding-vertical-normal padding-horizontal-medium flexbox border-bottom-medium border-shade-50">
    <div className="flexbox-no-grow padding-right-normal shade-30">
      <Icons.SearchIcon />
    </div>
    <div className="flexbox-grow">
      <input
        className="font-size-small black width-full border-none"
        type="text"
        autoFocus
        value={value || ''}
        {...restProps}
      />
    </div>
  </div>
)

Dropdown.Body = Body
Dropdown.Wrapper = Wrapper
Dropdown.Menu = Menu
Dropdown.Title = Title
Dropdown.Header = Header
Dropdown.Divider = Divider
Dropdown.Item = Item
Dropdown.Button = Button
Dropdown.SearchInput = SearchInput

export default Dropdown
